import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: any; output: any; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  AWSIPAddress: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  AWSTime: { input: any; output: any; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
}

/** Product AO Stock Level */
export interface AoStock {
  __typename?: 'AOStock';
  key: StateEnum;
  value: Scalars['Int']['output'];
}

export interface AdminOrder {
  __typename?: 'AdminOrder';
  id: Scalars['String']['output'];
  /** IvoiceIds for Order */
  invoiceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  marketplacerOrderId?: Maybe<Scalars['String']['output']>;
  marketplacerTransaction?: Maybe<MarketplacerTransaction>;
  orderError?: Maybe<Scalars['String']['output']>;
  paymentInfo?: Maybe<Array<Maybe<OrderPaymentInfo>>>;
  /** External OrderID for use in the url */
  permalink?: Maybe<Scalars['String']['output']>;
  processFlags?: Maybe<ProcessFlags>;
  validatedCart?: Maybe<ValidatedCart>;
}

export interface AdminOrderList {
  __typename?: 'AdminOrderList';
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  orders: Array<AdminOrder>;
  total?: Maybe<Scalars['Float']['output']>;
}

/** Product Advert */
export interface Advert {
  __typename?: 'Advert';
  aoStock: Array<AoStock>;
  available: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Additional domestic shipping cost for Advert in cents */
  itemAdditionalDomesticShippingCostInCents: Scalars['Int']['output'];
  /** Listed price for Advert in cents */
  priceInCents: Scalars['Int']['output'];
  /** Sale price for Advert in cents, is equal to price when not on sale */
  salePriceInCents: Scalars['Int']['output'];
  /** Total domestic shipping cost to ship 1 item in cents */
  totalDomesticShippingCostInCents: Scalars['Int']['output'];
  variants: Array<Variant>;
}

export interface AffiliatedProductsResponse {
  __typename?: 'AffiliatedProductsResponse';
  items?: Maybe<Array<Maybe<Product>>>;
  recommendationId?: Maybe<Scalars['String']['output']>;
}

export enum AnalyticsEventTypes {
  Checkout = 'CHECKOUT',
  ProductSearch = 'PRODUCT_SEARCH',
  ViewProduct = 'VIEW_PRODUCT'
}

export interface AnalyticsInput {
  context?: InputMaybe<Scalars['String']['input']>;
  eventType: AnalyticsEventTypes;
  itemId?: InputMaybe<Scalars['String']['input']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Event meta data in JSON string format */
  metadata?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface AnalyticsResponse {
  __typename?: 'AnalyticsResponse';
  success: Scalars['Boolean']['output'];
}

export enum AuthProvider {
  ApiKey = 'apiKey',
  Iam = 'iam',
  Oidc = 'oidc',
  UserPools = 'userPools'
}

export interface AuthRule {
  allow: AuthStrategy;
  groupClaim?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsField?: InputMaybe<Scalars['String']['input']>;
  identityClaim?: InputMaybe<Scalars['String']['input']>;
  mutations?: InputMaybe<Array<InputMaybe<ModelMutation>>>;
  operations?: InputMaybe<Array<InputMaybe<ModelOperation>>>;
  ownerField?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<AuthProvider>;
  queries?: InputMaybe<Array<InputMaybe<ModelQuery>>>;
}

export enum AuthStrategy {
  Groups = 'groups',
  Owner = 'owner',
  Private = 'private',
  Public = 'public'
}

export interface Category {
  __typename?: 'Category';
  availableForBeta?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  categorylevel?: Maybe<Scalars['Int']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  hideFromMenu?: Maybe<Scalars['Boolean']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  level1?: Maybe<Scalars['String']['output']>;
  level2?: Maybe<Scalars['String']['output']>;
  level3?: Maybe<Scalars['String']['output']>;
  mainCategoryBannerColor?: Maybe<Scalars['String']['output']>;
  mainCategoryBannerUrl?: Maybe<Scalars['String']['output']>;
  metadataDescription?: Maybe<Scalars['String']['output']>;
  metadataTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  richDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  subCategoryBannerColor?: Maybe<Scalars['String']['output']>;
  subCategoryBannerUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  tier1?: Maybe<Scalars['Boolean']['output']>;
  tileUrl?: Maybe<Scalars['String']['output']>;
}

export interface CheckoutProviderInput {
  deviceData?: InputMaybe<Scalars['String']['input']>;
  paymentNonce: Scalars['String']['input'];
  paymentProvider: PaymentProvider;
  providerParams?: InputMaybe<Scalars['String']['input']>;
  redirectCancellationUrl?: InputMaybe<Scalars['String']['input']>;
  redirectConfirmationUrl?: InputMaybe<Scalars['String']['input']>;
}

/** Coupon (return type) */
export interface Coupon {
  __typename?: 'Coupon';
  /** Unique coupon code */
  couponCode: Scalars['ID']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  /** Coupon description */
  description?: Maybe<Scalars['String']['output']>;
  /** Discount amount for DOLLAR_AMOUNT type in cents */
  dollarDiscount?: Maybe<Scalars['Int']['output']>;
  /** Coupon only valid for this email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Expiry Date of coupon */
  expiryDate?: Maybe<Scalars['String']['output']>;
  /** coupon has been deleted in lad */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  /** Maximum value of discount. */
  maximumDiscount: Scalars['Int']['output'];
  /** Minimum value of matching products in cart in cents */
  minimumAmount?: Maybe<Scalars['Int']['output']>;
  /** coupon can only be used in the mobile app */
  mobileOnly: Scalars['Boolean']['output'];
  /** Discount percentage for PERCENTAGE type */
  percentageDiscount?: Maybe<Scalars['Float']['output']>;
  /** Coupon valid only for following retailer */
  retailerId?: Maybe<Scalars['String']['output']>;
  /** If retailerId is not null – percentage of discount covered by retailer. Default = 100%. Only referenced during the financial reconciliation process */
  retailerPercentage: Scalars['Float']['output'];
  /** Start Date of coupon validity */
  startDate: Scalars['String']['output'];
  /** Type of Coupon */
  type: CouponTypeEnum;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** maximum uses per customer. Default = 1 */
  usesPerEmail: Scalars['Int']['output'];
}

/** Coupon (input from frontend) */
export interface CouponInput {
  /** Unique coupon code */
  couponCode: Scalars['ID']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['String']['input']>;
  /** Coupon description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Discount amount for DOLLAR_AMOUNT type in cents */
  dollarDiscount?: InputMaybe<Scalars['Int']['input']>;
  /** Coupon only valid for this email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Expiry Date of coupon */
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  /** coupon has been deleted in lad */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['String']['input']>;
  /** Maximum value of discount. */
  maximumDiscount: Scalars['Int']['input'];
  /** Minimum value of matching products in cart in cents */
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  /** coupon can only be used in the mobile app */
  mobileOnly: Scalars['Boolean']['input'];
  /** Discount percentage for PERCENTAGE type */
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>;
  /** Coupon valid only for following retailer */
  retailerId?: InputMaybe<Scalars['String']['input']>;
  /** If retailerId is not null – percentage of discount covered by retailer. Default = 100%. Only referenced during the financial reconciliation process */
  retailerPercentage: Scalars['Float']['input'];
  /** Start Date of coupon validity */
  startDate: Scalars['String']['input'];
  /** Type of Coupon */
  type: CouponTypeEnum;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** maximum uses per customer. Default = 1 */
  usesPerEmail: Scalars['Int']['input'];
}

export interface CouponList {
  __typename?: 'CouponList';
  coupons: Array<Coupon>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
}

export interface CouponResponse {
  __typename?: 'CouponResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

/** The type of the coupon */
export enum CouponTypeEnum {
  DollarAmount = 'DOLLAR_AMOUNT',
  FreeShipping = 'FREE_SHIPPING',
  Percentage = 'PERCENTAGE'
}

/** A set of address information */
export interface CreateOrderAddressInput {
  /** The primary address line */
  address: Scalars['String']['input'];
  /** The address' city/suburb */
  city: Scalars['String']['input'];
  /** The address' country code */
  country: Scalars['String']['input'];
  /** The address' postcode */
  postcode: Scalars['String']['input'];
  /** The address' state code */
  state: Scalars['String']['input'];
}

export interface CreateOrderCustomerDetailsInput {
  /** The customer's billing address */
  billingAddress?: InputMaybe<CreateOrderAddressInput>;
  /** Whether the billing address is the same as the shipping address */
  billingSameAsShippingAddress: Scalars['Boolean']['input'];
  /** The customer's email address */
  email: Scalars['String']['input'];
  /** The customer's first name */
  firstName: Scalars['String']['input'];
  /** The customer's phone/mobile number */
  phone: Scalars['String']['input'];
  /** The recipient's first name */
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's phone/mobile number */
  recipientMobile?: InputMaybe<Scalars['String']['input']>;
  /** Whether the recipient is confirmed to be 18 years or over */
  recipientOver18Confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The recipient's surname */
  recipientSurname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's shipping address */
  shippingAddress: CreateOrderAddressInput;
  /** The customer's surname */
  surname: Scalars['String']['input'];
}

export interface CreateOrderInput {
  /** Cart ID */
  cartId: Scalars['String']['input'];
  /** Applied coupon */
  coupon?: InputMaybe<Scalars['String']['input']>;
  /** Delivery information of the customer */
  customerDetails: CreateOrderCustomerDetailsInput;
  /** Total discount in cents */
  discountCents: Scalars['Int']['input'];
  /** GA information for tracking */
  gaAttributes?: InputMaybe<GoogleAnalyticsInput>;
  /** Items being bought */
  items: Array<CreateOrderItemInput>;
  /** Flag to show if the order comes from the mobile app, used for coupon validity */
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to show if the order comes from one touch checkout, used for skip optional validition */
  oneTouch?: InputMaybe<Scalars['String']['input']>;
  /** Payment provider information */
  paymentProviderAttributes: CheckoutProviderInput;
  /** Riskified data for order correction */
  riskifiedAttributes?: InputMaybe<RiskifiedSourceProvider>;
  /** Total shipping cost in cents */
  shippingCents: Scalars['Int']['input'];
  /** Tracing information for shopback */
  shopbackAttributes?: InputMaybe<ShopbackInput>;
  /** Subtotal price which includes the cart items total in cents */
  subtotalCents: Scalars['Int']['input'];
  /** Total price which includes both items and shipping costs in cents */
  totalCents: Scalars['Int']['input'];
}

export interface CreateOrderItemInput {
  /** Advert ID */
  advertId: Scalars['String']['input'];
  /** Lasoo DB product ID */
  productId: Scalars['Int']['input'];
  /** Quantity being bought */
  quantity: Scalars['Int']['input'];
  /** Retailer ID */
  retailerId: Scalars['String']['input'];
  /** Variant ID */
  variantId: Scalars['String']['input'];
}

export interface DiscountResult {
  __typename?: 'DiscountResult';
  /** Total discount in cents */
  discountCents: Scalars['Int']['output'];
  message?: Maybe<ValidationResultType>;
  /** result of coupon application */
  result: Scalars['String']['output'];
}

export interface GoogleAnalyticsInput {
  clientId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}

/** API Health Status */
export interface HealthCheck {
  __typename?: 'HealthCheck';
  status: Scalars['String']['output'];
  version: Scalars['String']['output'];
}

export interface HttpHeader {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

/** Shopping cart (return type) */
export interface LasooCart {
  __typename?: 'LasooCart';
  /** Gets a Payment Token for the cart */
  braintreePaymentToken?: Maybe<Scalars['String']['output']>;
  /** Unique cart ID */
  cartId: Scalars['ID']['output'];
  /** Coupon code used with this cart */
  coupon?: Maybe<Scalars['String']['output']>;
  /** The initial created time of the cart */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Delivery information of the customer */
  customerDetails?: Maybe<LasooCartCustomerDetails>;
  /** Total discount of the cart in cents */
  discountCents: DiscountResult;
  /** The TTL expiration */
  expiresAt?: Maybe<Scalars['Int']['output']>;
  /** Items being bought */
  items: Array<LasooCartItem>;
  /** Flag to show if the cart comes from the mobile app, used for coupon validity */
  mobileApp?: Maybe<Scalars['Boolean']['output']>;
  /** Total shipping cost of the cart in cents */
  shippingCents: Scalars['Int']['output'];
  /** Total shipping cost of the cart in cents */
  shippingCentsGrouped?: Maybe<Array<RetailerShipping>>;
  /** Subtotal price of the cart which includes the cart items total in cents */
  subtotalCents: Scalars['Int']['output'];
  /** Total price of the cart which includes both cart items and shipping costs in cents */
  totalCents: Scalars['Int']['output'];
  /** Total quantity of items in the cart */
  totalQuantity: Scalars['Int']['output'];
  /** The last updated date */
  updatedAtDate?: Maybe<Scalars['String']['output']>;
}

export enum LasooCartAction {
  AddCoupon = 'ADD_COUPON',
  AddToCart = 'ADD_TO_CART',
  RemoveFromCart = 'REMOVE_FROM_CART',
  UpdateCart = 'UPDATE_CART',
  UpdateCustomerDetails = 'UPDATE_CUSTOMER_DETAILS'
}

/** A set of address information */
export interface LasooCartAddress {
  __typename?: 'LasooCartAddress';
  /** The primary address line */
  address?: Maybe<Scalars['String']['output']>;
  /** The address' city/suburb */
  city?: Maybe<Scalars['String']['output']>;
  /** The address' country code */
  country?: Maybe<Scalars['String']['output']>;
  /** The address' postcode */
  postcode?: Maybe<Scalars['String']['output']>;
  /** The address' state code */
  state?: Maybe<Scalars['String']['output']>;
}

/** Input address information */
export interface LasooCartAddressInput {
  /** The primary address line */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The address' city/suburb */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The address' country code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The address' postcode */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** The address' state code */
  state?: InputMaybe<Scalars['String']['input']>;
}

/** The customer's delivery details */
export interface LasooCartCustomerDetails {
  __typename?: 'LasooCartCustomerDetails';
  /** The customer's billing address */
  billingAddress?: Maybe<LasooCartAddress>;
  /** Whether the billing address is the same as the shipping address */
  billingSameAsShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  /** The customer's email address */
  email?: Maybe<Scalars['String']['output']>;
  /** The customer's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The customer's phone/mobile number */
  phone?: Maybe<Scalars['String']['output']>;
  /** The recipient's first name */
  recipientFirstName?: Maybe<Scalars['String']['output']>;
  /** The recipient's phone/mobile number */
  recipientMobile?: Maybe<Scalars['String']['output']>;
  /** Whether the recipient is confirmed to be 18 years or over */
  recipientOver18Confirmed?: Maybe<Scalars['Boolean']['output']>;
  /** The recipient's surname */
  recipientSurname?: Maybe<Scalars['String']['output']>;
  /** The customer's shipping address */
  shippingAddress?: Maybe<LasooCartAddress>;
  /** The customer's surname */
  surname?: Maybe<Scalars['String']['output']>;
}

/** The input for the customer's delivery details */
export interface LasooCartCustomerDetailsInput {
  /** The customer's billing address */
  billingAddress?: InputMaybe<LasooCartAddressInput>;
  /** Whether the billing address is the same as the shipping address */
  billingSameAsShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The customer's phone/mobile number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's phone/mobile number */
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's phone/mobile number */
  recipientMobile?: InputMaybe<Scalars['String']['input']>;
  /** Whether the recipient is confirmed to be 18 years or over */
  recipientOver18Confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The recipient's phone/mobile number */
  recipientSurname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's shipping address */
  shippingAddress?: InputMaybe<LasooCartAddressInput>;
  /** The customer's surname */
  surname?: InputMaybe<Scalars['String']['input']>;
}

/** Shopping cart (input from frontend) */
export interface LasooCartInput {
  /** Cart ID */
  cartId?: InputMaybe<Scalars['ID']['input']>;
  /** Coupon code used with this cart */
  coupon?: InputMaybe<Scalars['String']['input']>;
  /** The initial created time of the cart */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Delivery information of the customer */
  customerDetails?: InputMaybe<LasooCartCustomerDetailsInput>;
  /** Items being bought */
  items: Array<LasooCartItemInput>;
  /** Flag to show if the cart comes from the mobile app, used for coupon validity */
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Item being bought (return type) */
export interface LasooCartItem {
  __typename?: 'LasooCartItem';
  /** Get the advert information for the cart item */
  advert?: Maybe<Advert>;
  /** Advert ID */
  advertId: Scalars['String']['output'];
  /** Get the total discount amount listed against the product (in cents) */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Get the product information for the cart item */
  product?: Maybe<Product>;
  /** Lasoo DB product ID */
  productId: Scalars['Int']['output'];
  /** Quantity being bought */
  quantity: Scalars['Int']['output'];
  /** Get the retailer information for the cart item */
  retailer?: Maybe<Retailer>;
  /** Retailer ID */
  retailerId: Scalars['String']['output'];
  /** The cart item's validity */
  status: LasooCartItemStatus;
  /** Get the variant information for the cart item */
  variant?: Maybe<Variant>;
  /** Variant ID */
  variantId: Scalars['String']['output'];
}

/** Item being bought (input from frontend) */
export interface LasooCartItemInput {
  /** MarketPlacer advert ID */
  advertId: Scalars['String']['input'];
  /** Lasoo DB product ID */
  productId: Scalars['Int']['input'];
  /** Quantity being bought */
  quantity: Scalars['Int']['input'];
  /** MarketPlacer retailer ID */
  retailerId: Scalars['String']['input'];
  /** MarketPlacer variant ID */
  variantId: Scalars['String']['input'];
}

/** Cart Item validity state */
export enum LasooCartItemStatus {
  AdvertMissing = 'ADVERT_MISSING',
  AdvertNoLongerAvailable = 'ADVERT_NO_LONGER_AVAILABLE',
  InventoryExceeded = 'INVENTORY_EXCEEDED',
  InventoryOutOfStock = 'INVENTORY_OUT_OF_STOCK',
  ProductExpired = 'PRODUCT_EXPIRED',
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  UnavailableForPostcode = 'UNAVAILABLE_FOR_POSTCODE',
  Valid = 'VALID',
  VariantMissing = 'VARIANT_MISSING',
  VariantNoLongerAvailable = 'VARIANT_NO_LONGER_AVAILABLE'
}

/** Shopping cart payment afterpay attributes (input from frontend) */
export interface LasooCartPaymentAfterpayAttributesInput {
  /** URL to redirect to if the payment is cancelled */
  redirectCancellationUrl: Scalars['String']['input'];
  /** URL to redirect to if the payment is confirmed */
  redirectConfirmationUrl: Scalars['String']['input'];
}

/** Afterpay create checkout result */
export interface LasooCartPaymentAfterpayResult {
  __typename?: 'LasooCartPaymentAfterpayResult';
  expires?: Maybe<Scalars['String']['output']>;
  redirectCheckoutUrl?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
}

/** A user's cart, if any */
export interface LasooCartResult {
  __typename?: 'LasooCartResult';
  cart?: Maybe<LasooCart>;
  error?: Maybe<UserActionError>;
}

/** Line Item */
export interface LineItem {
  __typename?: 'LineItem';
  advertId?: Maybe<Scalars['String']['output']>;
  advertTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  subtotalCents?: Maybe<Scalars['Int']['output']>;
  variantId?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  variantSku?: Maybe<Scalars['String']['output']>;
}

export interface MarketplacerTransaction {
  __typename?: 'MarketplacerTransaction';
  marketplacerErrors?: Maybe<Array<Maybe<ValidationError>>>;
  marketplacerMuationId: Scalars['String']['output'];
  outcome: OutcomeEnum;
  transactionDate?: Maybe<Scalars['String']['output']>;
}

export interface Measurement {
  __typename?: 'Measurement';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export enum ModelMutation {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

export interface ModelMutationMap {
  create?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<Scalars['String']['input']>;
}

export enum ModelOperation {
  Create = 'create',
  Delete = 'delete',
  Read = 'read',
  Update = 'update'
}

export enum ModelQuery {
  Get = 'get',
  List = 'list'
}

export interface ModelQueryMap {
  get?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['String']['input']>;
}

export enum ModelSubscriptionLevel {
  Off = 'off',
  On = 'on',
  Public = 'public'
}

export interface ModelSubscriptionMap {
  level?: InputMaybe<ModelSubscriptionLevel>;
  onCreate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Afterpay create checkout. */
  afterpayCreateCheckout: LasooCartPaymentAfterpayResult;
  /** Creates a new order */
  createOrder: OrderResult;
  trackEvent: AnalyticsResponse;
  /** Sets a whole cart. Used for debugging. */
  upsertCart: LasooCartResult;
  upsertCoupon: CouponResponse;
  upsertUserCoupon: UserCouponResponse;
  /** Create and validate a temporary cart for One Touch. This cart will not be saved to database. */
  validateTemporaryCart: LasooCartResult;
}


export interface MutationAfterpayCreateCheckoutArgs {
  cartId?: InputMaybe<Scalars['String']['input']>;
  params: LasooCartPaymentAfterpayAttributesInput;
}


export interface MutationCreateOrderArgs {
  input: CreateOrderInput;
}


export interface MutationTrackEventArgs {
  input: AnalyticsInput;
}


export interface MutationUpsertCartArgs {
  action?: InputMaybe<UpsertAction>;
  cart: LasooCartInput;
}


export interface MutationUpsertCouponArgs {
  coupon: CouponInput;
}


export interface MutationUpsertUserCouponArgs {
  userCoupon: UserCouponInput;
}


export interface MutationValidateTemporaryCartArgs {
  cart: LasooCartInput;
}

export interface Order {
  __typename?: 'Order';
  id?: Maybe<Scalars['String']['output']>;
  /** External OrderID for use in the url */
  permalink?: Maybe<Scalars['String']['output']>;
}

export interface OrderError {
  __typename?: 'OrderError';
  deleteCart?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  userPaid?: Maybe<Scalars['Boolean']['output']>;
  validationErrors?: Maybe<ValidationError>;
}

export interface OrderPaymentInfo {
  __typename?: 'OrderPaymentInfo';
  errors?: Maybe<Scalars['String']['output']>;
  paymentChannel: Scalars['String']['output'];
  paymentProviderUniqueID?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

export interface OrderResult {
  __typename?: 'OrderResult';
  errors?: Maybe<OrderError>;
  order?: Maybe<Order>;
  userActionError?: Maybe<UserActionError>;
}

export enum OutcomeEnum {
  Error = 'Error',
  Success = 'Success'
}

export interface PageDetails {
  __typename?: 'PageDetails';
  imageMap?: Maybe<Scalars['String']['output']>;
  onPage?: Maybe<Scalars['Int']['output']>;
  pageImage?: Maybe<Scalars['String']['output']>;
  productGroupId?: Maybe<Scalars['String']['output']>;
}

export interface PageLink {
  __typename?: 'PageLink';
  imagePath?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
}

export enum PaymentProvider {
  Afterpay = 'AFTERPAY',
  Braintree = 'BRAINTREE'
}

export enum PredictionsActions {
  ConvertTextToSpeech = 'convertTextToSpeech',
  IdentifyLabels = 'identifyLabels',
  IdentifyText = 'identifyText',
  TranslateText = 'translateText'
}

export interface ProcessFlags {
  __typename?: 'ProcessFlags';
  conversionSent: Scalars['Boolean']['output'];
  couponSaved: Scalars['Boolean']['output'];
  guestProfileCreated: Scalars['Boolean']['output'];
  orderSavedToLegacy: Scalars['Boolean']['output'];
  placedMarketplacerOrder: Scalars['Boolean']['output'];
  processedPayment: Scalars['Boolean']['output'];
  recordToKlaviyo: Scalars['Boolean']['output'];
  removedCart: Scalars['Boolean']['output'];
  sentInvoice: Scalars['Boolean']['output'];
  sentOrderResultToRiskified: Scalars['Boolean']['output'];
  subscribeToKlaviyo: Scalars['Boolean']['output'];
  trackedInShopback: Scalars['Boolean']['output'];
}

export interface Product {
  __typename?: 'Product';
  additionalImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  advertLookUp?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  buyNow?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']['output']>;
  categoryLevel?: Maybe<Scalars['Int']['output']>;
  categoryLevel1?: Maybe<Scalars['String']['output']>;
  categoryLevel2?: Maybe<Scalars['String']['output']>;
  categoryLevel3?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  forbiddenPostcodes?: Maybe<Array<Scalars['String']['output']>>;
  gender?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idAsString?: Maybe<Scalars['String']['output']>;
  imageMap?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  inWishList?: Maybe<Scalars['Boolean']['output']>;
  isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
  isDuplicate?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isPurchasableOnline?: Maybe<Scalars['Boolean']['output']>;
  itemGroupID?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  mpn?: Maybe<Scalars['String']['output']>;
  multiPrice?: Maybe<Scalars['Boolean']['output']>;
  multiVariant?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerTitle?: Maybe<Scalars['String']['output']>;
  onPage?: Maybe<Scalars['Int']['output']>;
  pageImage?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  postcodes?: Maybe<Array<Scalars['String']['output']>>;
  price?: Maybe<Scalars['Float']['output']>;
  productGroup?: Maybe<ProductGroup>;
  productGroupId?: Maybe<Scalars['Int']['output']>;
  productGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  productGroupPageDetails?: Maybe<Array<PageDetails>>;
  productMeasurement?: Maybe<Array<Maybe<Measurement>>>;
  productType?: Maybe<Scalars['String']['output']>;
  retailer?: Maybe<Retailer>;
  retailerId?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  salePriceDescription?: Maybe<Scalars['String']['output']>;
  savingsAbsolute?: Maybe<Scalars['Float']['output']>;
  savingsPercentage?: Maybe<Scalars['Float']['output']>;
  shippingDescription?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subBrand?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uomDescription?: Maybe<Scalars['String']['output']>;
  workflowStatus?: Maybe<Scalars['String']['output']>;
}

export interface ProductGroup {
  __typename?: 'ProductGroup';
  buyNow?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  forbiddenPostCodes?: Maybe<Array<Scalars['String']['output']>>;
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isBundle?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Array<ProductGroupMetadata>>;
  numberOfPages?: Maybe<Scalars['Int']['output']>;
  pageLinks?: Maybe<Array<PageLink>>;
  postcodes?: Maybe<Array<Scalars['String']['output']>>;
  productGroupId?: Maybe<Scalars['Int']['output']>;
  productGroupImage?: Maybe<Scalars['String']['output']>;
  productsTotal?: Maybe<Scalars['Int']['output']>;
  publicationDate?: Maybe<Scalars['String']['output']>;
  retailer?: Maybe<Retailer>;
  retailerId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProductGroupType>;
}

export interface ProductGroupMetadata {
  __typename?: 'ProductGroupMetadata';
  displayName?: Maybe<Scalars['String']['output']>;
  imageMap?: Maybe<Scalars['String']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  linkToPage?: Maybe<Scalars['String']['output']>;
  metaText?: Maybe<Scalars['String']['output']>;
  metaUrl?: Maybe<Scalars['String']['output']>;
  metadataId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  pageNo?: Maybe<Scalars['String']['output']>;
  productGroupId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
}

export enum ProductGroupType {
  Catalogue = 'Catalogue',
  CataloguePurchasable = 'CataloguePurchasable',
  CatalogueVirtual = 'CatalogueVirtual',
  Group = 'Group'
}

export interface Query {
  __typename?: 'Query';
  /** Gets an order by orderId for LAD */
  adminOrder: AdminOrder;
  adminOrderList: AdminOrderList;
  advert?: Maybe<Advert>;
  adverts?: Maybe<Array<Advert>>;
  affiliatedProducts: AffiliatedProductsResponse;
  /** Get braintree client authorization */
  braintreeClientAuth: Scalars['String']['output'];
  /** Gets the cart based on a cart ID. Fallback to get cart by userId. Returns null if the cart does not exist. */
  cart: LasooCartResult;
  coupon?: Maybe<Coupon>;
  couponsList: CouponList;
  getUserCouponUsage: Scalars['Float']['output'];
  healthCheck: HealthCheck;
  product?: Maybe<Product>;
  retailer?: Maybe<Retailer>;
  /**  Gets all shipments for an order */
  shipments?: Maybe<Array<Maybe<Shipment>>>;
  /** Gets the current cart for a Cognito user. Returns null if the user doesn't yet have a cart. */
  userCart: LasooCartResult;
  variant?: Maybe<Variant>;
}


export interface QueryAdminOrderArgs {
  orderId: Scalars['String']['input'];
}


export interface QueryAdminOrderListArgs {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryAdvertArgs {
  advertId: Scalars['String']['input'];
}


export interface QueryAdvertsArgs {
  advertIds: Array<Scalars['String']['input']>;
}


export interface QueryAffiliatedProductsArgs {
  categoryLevel?: InputMaybe<Scalars['Int']['input']>;
  categoryLevel1?: InputMaybe<Scalars['String']['input']>;
  categoryLevel2?: InputMaybe<Scalars['String']['input']>;
  categoryLevel3?: InputMaybe<Scalars['String']['input']>;
  numberOfProducts: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
}


export interface QueryCartArgs {
  cartId?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryCouponArgs {
  couponCode: Scalars['String']['input'];
}


export interface QueryCouponsListArgs {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CouponTypeEnum>;
  updatedSince?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetUserCouponUsageArgs {
  couponCode: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
}


export interface QueryProductArgs {
  productId: Scalars['String']['input'];
}


export interface QueryRetailerArgs {
  retailerId: Scalars['String']['input'];
}


export interface QueryShipmentsArgs {
  orderId: Scalars['String']['input'];
}


export interface QueryVariantArgs {
  advertId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
}

export interface Retailer {
  __typename?: 'Retailer';
  availableForBeta: Scalars['Boolean']['output'];
  brickAndMortar: Scalars['Boolean']['output'];
  colour?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  deliveryMethod: RetailerDeliveryMethodEnum;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  enableCampaignReport: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  logoUrlLarge?: Maybe<Scalars['String']['output']>;
  logoUrlSmall?: Maybe<Scalars['String']['output']>;
  metadataDescriptionProductGroup?: Maybe<Scalars['String']['output']>;
  metadataDescriptionRetailer?: Maybe<Scalars['String']['output']>;
  metadataTitleProductGroup?: Maybe<Scalars['String']['output']>;
  metadataTitleRetailer?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requireOverAgeCheck: Scalars['Boolean']['output'];
  retailerCategories: Array<Scalars['String']['output']>;
  shippingEstimationMessage?: Maybe<Scalars['String']['output']>;
  siteName: Scalars['String']['output'];
  telephone: Scalars['String']['output'];
  websiteURL: Scalars['String']['output'];
  xmlFeed: Scalars['Boolean']['output'];
}

export enum RetailerDeliveryMethodEnum {
  SameDay2023 = 'SameDay2023',
  SameDay2024 = 'SameDay2024',
  Standard = 'Standard'
}

/** groupped shipping costs */
export interface RetailerShipping {
  __typename?: 'RetailerShipping';
  /** Total price of items for the retailer */
  costInCents: Scalars['Int']['output'];
  /** retailer */
  retailer?: Maybe<Retailer>;
  /** retailerId */
  retailerId: Scalars['String']['output'];
}

export interface RiskifiedClientDetail {
  acceptLanguage: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
}

export interface RiskifiedPaymentDetail {
  bin?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  creditCardNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export enum RiskifiedSource {
  DesktopWeb = 'DesktopWeb',
  MobileApp = 'MobileApp',
  MobileAppAndroid = 'MobileAppAndroid',
  MobileAppIos = 'MobileAppIos',
  MobileWeb = 'MobileWeb',
  Unknown = 'Unknown',
  Web = 'Web'
}

export interface RiskifiedSourceProvider {
  /** Riskified Session Id */
  cartTokenId: Scalars['String']['input'];
  clientDetails: RiskifiedClientDetail;
  paymentDetails: RiskifiedPaymentDetail;
  referringSite?: InputMaybe<Scalars['String']['input']>;
  source: RiskifiedSource;
}

export interface SearchableQueryMap {
  search?: InputMaybe<Scalars['String']['input']>;
}

/** Shipment Tracking */
export interface Shipment {
  __typename?: 'Shipment';
  afterShipTrackingId?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  dispatchedAt?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDateMax?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDateMin?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  shipmentDeliveryDate?: Maybe<Scalars['String']['output']>;
  shipmentId: Scalars['String']['output'];
  shippedItems?: Maybe<Array<Maybe<ShippedItem>>>;
  /** aftership tracking status */
  shippingStatus?: Maybe<ShippingStatus>;
  trackingLink?: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
}

/** Shipped Item */
export interface ShippedItem {
  __typename?: 'ShippedItem';
  lineItem?: Maybe<LineItem>;
  quantity?: Maybe<Scalars['Int']['output']>;
  shippedItemId: Scalars['Int']['output'];
}

/** status of aftership tracking */
export enum ShippingStatus {
  AvailableForPickup = 'AvailableForPickup',
  Delivered = 'Delivered',
  Exception = 'Exception',
  Expired = 'Expired',
  FailedAttempt = 'FailedAttempt',
  InTransit = 'InTransit',
  InfoReceived = 'InfoReceived',
  OutForDelivery = 'OutForDelivery',
  Pending = 'Pending'
}

export interface ShopbackInput {
  transactionId: Scalars['String']['input'];
}

/** State of Australia */
export enum StateEnum {
  Nsw = 'NSW',
  Nt = 'NT',
  Qld = 'QLD',
  Sa = 'SA',
  Tas = 'TAS',
  Vic = 'VIC',
  Wa = 'WA'
}

export interface TimestampConfiguration {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
}

export interface UpsertAction {
  action?: InputMaybe<LasooCartAction>;
}

export interface UserActionError {
  __typename?: 'UserActionError';
  /** Should client delete cart */
  delete_cart?: Maybe<Scalars['Boolean']['output']>;
  /** The detailed message */
  error_message?: Maybe<Scalars['String']['output']>;
  /** The main error */
  error_title?: Maybe<Scalars['String']['output']>;
  /** The address home */
  navigate_to?: Maybe<Scalars['String']['output']>;
}

export interface UserCouponInput {
  /** Coupon code used */
  couponCode: Scalars['String']['input'];
  /** Date coupon used */
  dateUsed: Scalars['DateTime']['input'];
  /** Email address associated with order */
  emailAddress: Scalars['String']['input'];
  /** Id of order coupon used on */
  orderId: Scalars['String']['input'];
  /** UserId that used coupon */
  userId: Scalars['String']['input'];
}

export interface UserCouponResponse {
  __typename?: 'UserCouponResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface ValidatedCart {
  __typename?: 'ValidatedCart';
  cartId: Scalars['String']['output'];
  coupon?: Maybe<Scalars['String']['output']>;
  customerDetails: ValidatedCartCustomerDetails;
  discountCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
}

export interface ValidatedCartCustomerDetails {
  __typename?: 'ValidatedCartCustomerDetails';
  billingEmail: Scalars['String']['output'];
  billingFirstName: Scalars['String']['output'];
  billingPhone: Scalars['String']['output'];
  billingSurname: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  surname: Scalars['String']['output'];
}

export interface ValidationError {
  __typename?: 'ValidationError';
  field?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

/** Validation result */
export enum ValidationResultType {
  BelowMinCoupon = 'BELOW_MIN_COUPON',
  FailedToFetchRetailer = 'FAILED_TO_FETCH_RETAILER',
  FailedToFetchShipping = 'FAILED_TO_FETCH_SHIPPING',
  FailedToValidateCoupon = 'FAILED_TO_VALIDATE_COUPON',
  InvalidAddress = 'INVALID_ADDRESS',
  InvalidCoupon = 'INVALID_COUPON',
  InvalidCouponProducts = 'INVALID_COUPON_PRODUCTS',
  InvalidCustomerDetailsEmail = 'INVALID_CUSTOMER_DETAILS_EMAIL',
  InvalidCustomerDetailsName = 'INVALID_CUSTOMER_DETAILS_NAME',
  InvalidCustomerDetailsPhone = 'INVALID_CUSTOMER_DETAILS_PHONE',
  InvalidItems = 'INVALID_ITEMS',
  MobileOnlyCoupon = 'MOBILE_ONLY_COUPON',
  NoCartId = 'NO_CART_ID',
  NoItems = 'NO_ITEMS',
  PriceMismatch = 'PRICE_MISMATCH',
  PricingFailure = 'PRICING_FAILURE',
  RequireOver_18 = 'REQUIRE_OVER_18',
  ReusedCoupon = 'REUSED_COUPON',
  Valid = 'VALID'
}

/** Product Variant */
export interface Variant {
  __typename?: 'Variant';
  advancedShippingCostForVariant?: Maybe<Scalars['Int']['output']>;
  available: Scalars['Boolean']['output'];
  availableQuantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Listed price for Variant in cents */
  priceInCents: Scalars['Int']['output'];
  /** Sale price for Variant in cents, is equal to Variant price when not on sale */
  salePriceInCents: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
}


/** Product Variant */
export interface VariantAdvancedShippingCostForVariantArgs {
  retailerId: Scalars['String']['input'];
}

export type CartFragmentFragment = { __typename: 'LasooCart', cartId: string, createdAt?: string | null, braintreePaymentToken?: string | null, coupon?: string | null, totalQuantity: number, shippingCents: number, subtotalCents: number, totalCents: number, items: Array<{ __typename?: 'LasooCartItem', productId: number, advertId: string, variantId: string, retailerId: string, quantity: number, discount?: number | null, status: LasooCartItemStatus, product?: { __typename?: 'Product', isHidden?: boolean | null, title?: string | null, salePriceDescription?: string | null, imageUrl?: string | null, category?: { __typename?: 'Category', level1?: string | null } | null } | null, variant?: { __typename?: 'Variant', id: string, available: boolean, availableQuantity: number, priceInCents: number, sku?: string | null, salePriceInCents: number, label: string } | null, advert?: { __typename?: 'Advert', available: boolean, totalDomesticShippingCostInCents: number, id: string, priceInCents: number, salePriceInCents: number, itemAdditionalDomesticShippingCostInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', id: string, availableQuantity: number, available: boolean, sku?: string | null, label: string, priceInCents: number, salePriceInCents: number }> } | null, retailer?: { __typename?: 'Retailer', id: string, displayName: string, logoUrl?: string | null, colour?: string | null, shippingEstimationMessage?: string | null, requireOverAgeCheck: boolean, deliveryMethod: RetailerDeliveryMethodEnum, country: string, availableForBeta: boolean, email: string, brickAndMortar: boolean, enableCampaignReport: boolean, isPublished: boolean, name: string, retailerCategories: Array<string>, siteName: string, telephone: string, websiteURL: string, xmlFeed: boolean } | null }>, customerDetails?: { __typename?: 'LasooCartCustomerDetails', phone?: string | null, email?: string | null, firstName?: string | null, surname?: string | null, recipientFirstName?: string | null, recipientSurname?: string | null, recipientMobile?: string | null, recipientOver18Confirmed?: boolean | null, billingSameAsShippingAddress?: boolean | null, shippingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null, billingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null } | null, shippingCentsGrouped?: Array<{ __typename?: 'RetailerShipping', costInCents: number, retailerId: string, retailer?: { __typename?: 'Retailer', name: string } | null }> | null, discountCents: { __typename?: 'DiscountResult', result: string, discountCents: number, message?: ValidationResultType | null } };

export type ProductGroupPartsFragment = { __typename?: 'ProductGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string> | null };

export type RetailerPartsFragment = { __typename?: 'Retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id: string, retailer_displayName: string, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck: boolean, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL: string, retailer_deliveryMethod: RetailerDeliveryMethodEnum };

export type AfterpayCreateCheckoutMutationVariables = Exact<{
  params: LasooCartPaymentAfterpayAttributesInput;
  cartId: Scalars['String']['input'];
}>;


export type AfterpayCreateCheckoutMutation = { __typename?: 'Mutation', afterpayCreateCheckout: { __typename: 'LasooCartPaymentAfterpayResult', token?: string | null, redirectCheckoutUrl?: string | null, expires?: string | null } };

export type PlaceOrderMutationVariables = Exact<{
  orderInput: CreateOrderInput;
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'OrderResult', errors?: { __typename: 'OrderError', message?: string | null, deleteCart?: boolean | null, userPaid?: boolean | null, permalink?: string | null, validationErrors?: { __typename?: 'ValidationError', field?: string | null, messages?: Array<string | null> | null } | null } | null, order?: { __typename: 'Order', id?: string | null, permalink?: string | null } | null, userActionError?: { __typename: 'UserActionError', error_message?: string | null, error_title?: string | null, navigate_to?: string | null, delete_cart?: boolean | null } | null } };

export type ValidateTemporaryCartMutationVariables = Exact<{
  cart: LasooCartInput;
}>;


export type ValidateTemporaryCartMutation = { __typename?: 'Mutation', validateTemporaryCart: { __typename: 'LasooCartResult', cart?: { __typename: 'LasooCart', cartId: string, createdAt?: string | null, braintreePaymentToken?: string | null, coupon?: string | null, totalQuantity: number, shippingCents: number, subtotalCents: number, totalCents: number, items: Array<{ __typename?: 'LasooCartItem', productId: number, advertId: string, variantId: string, retailerId: string, quantity: number, discount?: number | null, status: LasooCartItemStatus, product?: { __typename?: 'Product', isHidden?: boolean | null, title?: string | null, salePriceDescription?: string | null, imageUrl?: string | null, category?: { __typename?: 'Category', level1?: string | null } | null } | null, variant?: { __typename?: 'Variant', id: string, available: boolean, availableQuantity: number, priceInCents: number, sku?: string | null, salePriceInCents: number, label: string } | null, advert?: { __typename?: 'Advert', available: boolean, totalDomesticShippingCostInCents: number, id: string, priceInCents: number, salePriceInCents: number, itemAdditionalDomesticShippingCostInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', id: string, availableQuantity: number, available: boolean, sku?: string | null, label: string, priceInCents: number, salePriceInCents: number }> } | null, retailer?: { __typename?: 'Retailer', id: string, displayName: string, logoUrl?: string | null, colour?: string | null, shippingEstimationMessage?: string | null, requireOverAgeCheck: boolean, deliveryMethod: RetailerDeliveryMethodEnum, country: string, availableForBeta: boolean, email: string, brickAndMortar: boolean, enableCampaignReport: boolean, isPublished: boolean, name: string, retailerCategories: Array<string>, siteName: string, telephone: string, websiteURL: string, xmlFeed: boolean } | null }>, customerDetails?: { __typename?: 'LasooCartCustomerDetails', phone?: string | null, email?: string | null, firstName?: string | null, surname?: string | null, recipientFirstName?: string | null, recipientSurname?: string | null, recipientMobile?: string | null, recipientOver18Confirmed?: boolean | null, billingSameAsShippingAddress?: boolean | null, shippingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null, billingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null } | null, shippingCentsGrouped?: Array<{ __typename?: 'RetailerShipping', costInCents: number, retailerId: string, retailer?: { __typename?: 'Retailer', name: string } | null }> | null, discountCents: { __typename?: 'DiscountResult', result: string, discountCents: number, message?: ValidationResultType | null } } | null } };

export type TrackEventMutationVariables = Exact<{
  input: AnalyticsInput;
}>;


export type TrackEventMutation = { __typename?: 'Mutation', trackEvent: { __typename?: 'AnalyticsResponse', success: boolean } };

export type UpsertCartMutationVariables = Exact<{
  cart: LasooCartInput;
  action?: InputMaybe<UpsertAction>;
}>;


export type UpsertCartMutation = { __typename?: 'Mutation', upsertCart: { __typename: 'LasooCartResult', cart?: { __typename: 'LasooCart', cartId: string, createdAt?: string | null, braintreePaymentToken?: string | null, coupon?: string | null, totalQuantity: number, shippingCents: number, subtotalCents: number, totalCents: number, items: Array<{ __typename?: 'LasooCartItem', productId: number, advertId: string, variantId: string, retailerId: string, quantity: number, discount?: number | null, status: LasooCartItemStatus, product?: { __typename?: 'Product', isHidden?: boolean | null, title?: string | null, salePriceDescription?: string | null, imageUrl?: string | null, category?: { __typename?: 'Category', level1?: string | null } | null } | null, variant?: { __typename?: 'Variant', id: string, available: boolean, availableQuantity: number, priceInCents: number, sku?: string | null, salePriceInCents: number, label: string } | null, advert?: { __typename?: 'Advert', available: boolean, totalDomesticShippingCostInCents: number, id: string, priceInCents: number, salePriceInCents: number, itemAdditionalDomesticShippingCostInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', id: string, availableQuantity: number, available: boolean, sku?: string | null, label: string, priceInCents: number, salePriceInCents: number }> } | null, retailer?: { __typename?: 'Retailer', id: string, displayName: string, logoUrl?: string | null, colour?: string | null, shippingEstimationMessage?: string | null, requireOverAgeCheck: boolean, deliveryMethod: RetailerDeliveryMethodEnum, country: string, availableForBeta: boolean, email: string, brickAndMortar: boolean, enableCampaignReport: boolean, isPublished: boolean, name: string, retailerCategories: Array<string>, siteName: string, telephone: string, websiteURL: string, xmlFeed: boolean } | null }>, customerDetails?: { __typename?: 'LasooCartCustomerDetails', phone?: string | null, email?: string | null, firstName?: string | null, surname?: string | null, recipientFirstName?: string | null, recipientSurname?: string | null, recipientMobile?: string | null, recipientOver18Confirmed?: boolean | null, billingSameAsShippingAddress?: boolean | null, shippingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null, billingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null } | null, shippingCentsGrouped?: Array<{ __typename?: 'RetailerShipping', costInCents: number, retailerId: string, retailer?: { __typename?: 'Retailer', name: string } | null }> | null, discountCents: { __typename?: 'DiscountResult', result: string, discountCents: number, message?: ValidationResultType | null } } | null } };

export type AdvertQueryVariables = Exact<{
  advertId: Scalars['String']['input'];
  retailerId: Scalars['String']['input'];
}>;


export type AdvertQuery = { __typename?: 'Query', advert?: { __typename?: 'Advert', available: boolean, totalDomesticShippingCostInCents: number, itemAdditionalDomesticShippingCostInCents: number, priceInCents: number, salePriceInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', available: boolean, availableQuantity: number, id: string, priceInCents: number, salePriceInCents: number, sku?: string | null, label: string, advancedShippingCostForVariant?: number | null }> } | null };

export type AdvertsQueryVariables = Exact<{
  advertIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AdvertsQuery = { __typename?: 'Query', adverts?: Array<{ __typename?: 'Advert', id: string, available: boolean, totalDomesticShippingCostInCents: number, itemAdditionalDomesticShippingCostInCents: number, priceInCents: number, salePriceInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', available: boolean, availableQuantity: number, id: string, priceInCents: number, salePriceInCents: number, sku?: string | null, label: string }> }> | null };

export type AffiliateProductsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  numberOfProducts: Scalars['Int']['input'];
  categoryLevel1: Scalars['String']['input'];
  categoryLevel2: Scalars['String']['input'];
  categoryLevel3: Scalars['String']['input'];
  categoryLevel: Scalars['Int']['input'];
}>;


export type AffiliateProductsQuery = { __typename?: 'Query', affiliatedProducts: { __typename?: 'AffiliatedProductsResponse', recommendationId?: string | null, items?: Array<{ __typename?: 'Product', advertLookUp?: string | null, brand?: string | null, buyNow?: boolean | null, endDate?: string | null, hideDate?: boolean | null, id?: number | null, imageUrl?: string | null, multiPrice?: boolean | null, multiVariant?: boolean | null, name?: string | null, offerTitle?: string | null, price?: number | null, retailerId?: string | null, salePrice?: number | null, savingsPercentage?: number | null, startDate?: string | null, uomDescription?: string | null, category?: { __typename?: 'Category', name?: string | null, categoryId?: string | null } | null, retailer?: { __typename?: 'Retailer', description?: string | null, displayName: string, id: string, name: string } | null } | null> | null } };

export type GetBraintreeClientAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBraintreeClientAuthQuery = { __typename?: 'Query', braintreeClientAuth: string };

export type CartWithPaymentQueryVariables = Exact<{
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CartWithPaymentQuery = { __typename?: 'Query', cart: { __typename: 'LasooCartResult', cart?: { __typename: 'LasooCart', braintreePaymentToken?: string | null, cartId: string, createdAt?: string | null, coupon?: string | null, totalQuantity: number, shippingCents: number, subtotalCents: number, totalCents: number, items: Array<{ __typename?: 'LasooCartItem', productId: number, advertId: string, variantId: string, retailerId: string, quantity: number, discount?: number | null, status: LasooCartItemStatus, product?: { __typename?: 'Product', isHidden?: boolean | null, title?: string | null, salePriceDescription?: string | null, imageUrl?: string | null, category?: { __typename?: 'Category', level1?: string | null } | null } | null, variant?: { __typename?: 'Variant', id: string, available: boolean, availableQuantity: number, priceInCents: number, sku?: string | null, salePriceInCents: number, label: string } | null, advert?: { __typename?: 'Advert', available: boolean, totalDomesticShippingCostInCents: number, id: string, priceInCents: number, salePriceInCents: number, itemAdditionalDomesticShippingCostInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', id: string, availableQuantity: number, available: boolean, sku?: string | null, label: string, priceInCents: number, salePriceInCents: number }> } | null, retailer?: { __typename?: 'Retailer', id: string, displayName: string, logoUrl?: string | null, colour?: string | null, shippingEstimationMessage?: string | null, requireOverAgeCheck: boolean, deliveryMethod: RetailerDeliveryMethodEnum, country: string, availableForBeta: boolean, email: string, brickAndMortar: boolean, enableCampaignReport: boolean, isPublished: boolean, name: string, retailerCategories: Array<string>, siteName: string, telephone: string, websiteURL: string, xmlFeed: boolean } | null }>, customerDetails?: { __typename?: 'LasooCartCustomerDetails', phone?: string | null, email?: string | null, firstName?: string | null, surname?: string | null, recipientFirstName?: string | null, recipientSurname?: string | null, recipientMobile?: string | null, recipientOver18Confirmed?: boolean | null, billingSameAsShippingAddress?: boolean | null, shippingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null, billingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null } | null, shippingCentsGrouped?: Array<{ __typename?: 'RetailerShipping', costInCents: number, retailerId: string, retailer?: { __typename?: 'Retailer', name: string } | null }> | null, discountCents: { __typename?: 'DiscountResult', result: string, discountCents: number, message?: ValidationResultType | null } } | null } };

export type CartQueryVariables = Exact<{
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CartQuery = { __typename?: 'Query', cart: { __typename: 'LasooCartResult', cart?: { __typename: 'LasooCart', cartId: string, createdAt?: string | null, braintreePaymentToken?: string | null, coupon?: string | null, totalQuantity: number, shippingCents: number, subtotalCents: number, totalCents: number, items: Array<{ __typename?: 'LasooCartItem', productId: number, advertId: string, variantId: string, retailerId: string, quantity: number, discount?: number | null, status: LasooCartItemStatus, product?: { __typename?: 'Product', isHidden?: boolean | null, title?: string | null, salePriceDescription?: string | null, imageUrl?: string | null, category?: { __typename?: 'Category', level1?: string | null } | null } | null, variant?: { __typename?: 'Variant', id: string, available: boolean, availableQuantity: number, priceInCents: number, sku?: string | null, salePriceInCents: number, label: string } | null, advert?: { __typename?: 'Advert', available: boolean, totalDomesticShippingCostInCents: number, id: string, priceInCents: number, salePriceInCents: number, itemAdditionalDomesticShippingCostInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', id: string, availableQuantity: number, available: boolean, sku?: string | null, label: string, priceInCents: number, salePriceInCents: number }> } | null, retailer?: { __typename?: 'Retailer', id: string, displayName: string, logoUrl?: string | null, colour?: string | null, shippingEstimationMessage?: string | null, requireOverAgeCheck: boolean, deliveryMethod: RetailerDeliveryMethodEnum, country: string, availableForBeta: boolean, email: string, brickAndMortar: boolean, enableCampaignReport: boolean, isPublished: boolean, name: string, retailerCategories: Array<string>, siteName: string, telephone: string, websiteURL: string, xmlFeed: boolean } | null }>, customerDetails?: { __typename?: 'LasooCartCustomerDetails', phone?: string | null, email?: string | null, firstName?: string | null, surname?: string | null, recipientFirstName?: string | null, recipientSurname?: string | null, recipientMobile?: string | null, recipientOver18Confirmed?: boolean | null, billingSameAsShippingAddress?: boolean | null, shippingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null, billingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null } | null, shippingCentsGrouped?: Array<{ __typename?: 'RetailerShipping', costInCents: number, retailerId: string, retailer?: { __typename?: 'Retailer', name: string } | null }> | null, discountCents: { __typename?: 'DiscountResult', result: string, discountCents: number, message?: ValidationResultType | null } } | null } };

export type CouponQueryVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type CouponQuery = { __typename?: 'Query', coupon?: { __typename: 'Coupon', couponCode: string, description?: string | null, type: CouponTypeEnum, startDate: string, expiryDate?: string | null, dollarDiscount?: number | null, percentageDiscount?: number | null, retailerId?: string | null, retailerPercentage: number, email?: string | null, usesPerEmail: number, minimumAmount?: number | null, maximumDiscount: number, mobileOnly: boolean } | null };

export type ProductQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename: 'Product', entityType?: string | null, product_id?: string | null, product_startDate?: string | null, product_endDate?: string | null, product_hideDate?: boolean | null, product_productGroupId?: number | null, product_brand?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_shippingDescription?: string | null, product_savingsAbsolute?: number | null, product_savingsPercentage?: number | null, product_description?: string | null, product_linkUrl?: string | null, product_name?: string | null, product_categoryName?: string | null, product_categoryId?: string | null, product_imageUrl?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_buyNow?: boolean | null, product_retailerId?: string | null, product_isPurchasableOnline?: boolean | null, product_multiVariant?: boolean | null, product_multiPrice?: boolean | null, product_advertLookUp?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_isHidden?: boolean | null, product_isDuplicate?: boolean | null, product_productGroup?: { __typename?: 'ProductGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string> | null } | null, product_retailer?: { __typename?: 'Retailer', retailer_shippingEstimationMessage?: string | null, retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id: string, retailer_displayName: string, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck: boolean, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL: string, retailer_deliveryMethod: RetailerDeliveryMethodEnum } | null, product_pageDetails?: Array<{ __typename?: 'PageDetails', imageMap?: string | null, onPage?: number | null, pageImage?: string | null, productGroupId?: string | null }> | null } | null };

export type ShipmentsQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ShipmentsQuery = { __typename?: 'Query', shipments?: Array<{ __typename?: 'Shipment', estimatedDeliveryDate?: string | null, shipmentId: string, shippingStatus?: ShippingStatus | null, trackingNumber: string, shippedItems?: Array<{ __typename?: 'ShippedItem', shippedItemId: number, lineItem?: { __typename?: 'LineItem', id: string } | null } | null> | null } | null> | null };

export type GetUserCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCartQuery = { __typename?: 'Query', userCart: { __typename: 'LasooCartResult', cart?: { __typename: 'LasooCart', cartId: string, createdAt?: string | null, braintreePaymentToken?: string | null, coupon?: string | null, totalQuantity: number, shippingCents: number, subtotalCents: number, totalCents: number, items: Array<{ __typename?: 'LasooCartItem', productId: number, advertId: string, variantId: string, retailerId: string, quantity: number, discount?: number | null, status: LasooCartItemStatus, product?: { __typename?: 'Product', isHidden?: boolean | null, title?: string | null, salePriceDescription?: string | null, imageUrl?: string | null, category?: { __typename?: 'Category', level1?: string | null } | null } | null, variant?: { __typename?: 'Variant', id: string, available: boolean, availableQuantity: number, priceInCents: number, sku?: string | null, salePriceInCents: number, label: string } | null, advert?: { __typename?: 'Advert', available: boolean, totalDomesticShippingCostInCents: number, id: string, priceInCents: number, salePriceInCents: number, itemAdditionalDomesticShippingCostInCents: number, aoStock: Array<{ __typename?: 'AOStock', key: StateEnum, value: number }>, variants: Array<{ __typename?: 'Variant', id: string, availableQuantity: number, available: boolean, sku?: string | null, label: string, priceInCents: number, salePriceInCents: number }> } | null, retailer?: { __typename?: 'Retailer', id: string, displayName: string, logoUrl?: string | null, colour?: string | null, shippingEstimationMessage?: string | null, requireOverAgeCheck: boolean, deliveryMethod: RetailerDeliveryMethodEnum, country: string, availableForBeta: boolean, email: string, brickAndMortar: boolean, enableCampaignReport: boolean, isPublished: boolean, name: string, retailerCategories: Array<string>, siteName: string, telephone: string, websiteURL: string, xmlFeed: boolean } | null }>, customerDetails?: { __typename?: 'LasooCartCustomerDetails', phone?: string | null, email?: string | null, firstName?: string | null, surname?: string | null, recipientFirstName?: string | null, recipientSurname?: string | null, recipientMobile?: string | null, recipientOver18Confirmed?: boolean | null, billingSameAsShippingAddress?: boolean | null, shippingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null, billingAddress?: { __typename?: 'LasooCartAddress', address?: string | null, city?: string | null, country?: string | null, postcode?: string | null, state?: string | null } | null } | null, shippingCentsGrouped?: Array<{ __typename?: 'RetailerShipping', costInCents: number, retailerId: string, retailer?: { __typename?: 'Retailer', name: string } | null }> | null, discountCents: { __typename?: 'DiscountResult', result: string, discountCents: number, message?: ValidationResultType | null } } | null } };

export type VariantQueryVariables = Exact<{
  advertId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
  retailerId: Scalars['String']['input'];
}>;


export type VariantQuery = { __typename?: 'Query', variant?: { __typename?: 'Variant', available: boolean, availableQuantity: number, id: string, priceInCents: number, salePriceInCents: number, advancedShippingCostForVariant?: number | null } | null };

export const CartFragment = gql`
    fragment CartFragment on LasooCart {
  __typename
  cartId
  createdAt
  items {
    productId
    advertId
    variantId
    retailerId
    quantity
    discount
    status
    product {
      isHidden
      title
      salePriceDescription
      category {
        level1
      }
      imageUrl
    }
    variant {
      id
      available
      availableQuantity
      priceInCents
      sku
      salePriceInCents
      label
    }
    advert {
      available
      totalDomesticShippingCostInCents
      id
      priceInCents
      salePriceInCents
      aoStock {
        key
        value
      }
      itemAdditionalDomesticShippingCostInCents
      variants {
        id
        availableQuantity
        available
        sku
        label
        priceInCents
        salePriceInCents
      }
    }
    retailer {
      id
      displayName
      logoUrl
      colour
      shippingEstimationMessage
      requireOverAgeCheck
      deliveryMethod
      country
      availableForBeta
      email
      brickAndMortar
      enableCampaignReport
      isPublished
      name
      retailerCategories
      siteName
      telephone
      websiteURL
      xmlFeed
    }
  }
  customerDetails {
    phone
    email
    firstName
    surname
    recipientFirstName
    recipientSurname
    recipientMobile
    recipientOver18Confirmed
    billingSameAsShippingAddress
    shippingAddress {
      address
      city
      country
      postcode
      state
    }
    billingAddress {
      address
      city
      country
      postcode
      state
    }
  }
  shippingCentsGrouped {
    costInCents
    retailer {
      name
    }
    retailerId
  }
  braintreePaymentToken
  coupon
  totalQuantity
  shippingCents
  discountCents {
    result
    discountCents
    message
  }
  subtotalCents
  totalCents
}
    `;
export const ProductGroupParts = gql`
    fragment ProductGroupParts on ProductGroup {
  productGroup_type: type
  productGroup_displayName: displayName
  productGroup_forbiddenPostCodes: forbiddenPostCodes
}
    `;
export const RetailerParts = gql`
    fragment RetailerParts on Retailer {
  retailer_colour: colour
  retailer_logoUrl: logoUrl
  retailer_id: id
  retailer_displayName: displayName
  retailer_logoUrlSmall: logoUrlSmall
  retailer_logoUrlLarge: logoUrlLarge
  retailer_requireOverAgeCheck: requireOverAgeCheck
  retailer_metadataTitleRetailer: metadataTitleRetailer
  retailer_metadataDescriptionRetailer: metadataDescriptionRetailer
  retailer_metadataTitleProductGroup: metadataTitleProductGroup
  retailer_metadataDescriptionProductGroup: metadataDescriptionProductGroup
  retailer_websiteURL: websiteURL
  retailer_deliveryMethod: deliveryMethod
}
    `;
export const AfterpayCreateCheckout = gql`
    mutation afterpayCreateCheckout($params: LasooCartPaymentAfterpayAttributesInput!, $cartId: String!) {
  afterpayCreateCheckout(cartId: $cartId, params: $params) {
    __typename
    token
    redirectCheckoutUrl
    expires
  }
}
    `;
export const PlaceOrder = gql`
    mutation placeOrder($orderInput: CreateOrderInput!) {
  createOrder(input: $orderInput) {
    errors {
      __typename
      message
      validationErrors {
        field
        messages
      }
      deleteCart
      userPaid
      permalink
    }
    order {
      __typename
      id
      permalink
    }
    userActionError {
      __typename
      error_message
      error_title
      navigate_to
      delete_cart
    }
  }
}
    `;
export const ValidateTemporaryCart = gql`
    mutation validateTemporaryCart($cart: LasooCartInput!) {
  validateTemporaryCart(cart: $cart) {
    __typename
    cart {
      ...CartFragment
    }
  }
}
    ${CartFragment}`;
export const TrackEvent = gql`
    mutation TrackEvent($input: AnalyticsInput!) {
  trackEvent(input: $input) {
    success
  }
}
    `;
export const UpsertCart = gql`
    mutation upsertCart($cart: LasooCartInput!, $action: UpsertAction) {
  upsertCart(cart: $cart, action: $action) {
    __typename
    cart {
      ...CartFragment
    }
  }
}
    ${CartFragment}`;
export const Advert = gql`
    query Advert($advertId: String!, $retailerId: String!) {
  advert(advertId: $advertId) {
    aoStock {
      key
      value
    }
    available
    totalDomesticShippingCostInCents
    itemAdditionalDomesticShippingCostInCents
    priceInCents
    salePriceInCents
    variants {
      available
      availableQuantity
      id
      priceInCents
      salePriceInCents
      sku
      label
      advancedShippingCostForVariant(retailerId: $retailerId)
    }
  }
}
    `;
export const Adverts = gql`
    query Adverts($advertIds: [String!]!) {
  adverts(advertIds: $advertIds) {
    id
    aoStock {
      key
      value
    }
    available
    totalDomesticShippingCostInCents
    itemAdditionalDomesticShippingCostInCents
    priceInCents
    salePriceInCents
    variants {
      available
      availableQuantity
      id
      priceInCents
      salePriceInCents
      sku
      label
    }
  }
}
    `;
export const AffiliateProducts = gql`
    query AffiliateProducts($productId: String!, $numberOfProducts: Int!, $categoryLevel1: String!, $categoryLevel2: String!, $categoryLevel3: String!, $categoryLevel: Int!) {
  affiliatedProducts(
    numberOfProducts: $numberOfProducts
    productId: $productId
    categoryLevel1: $categoryLevel1
    categoryLevel2: $categoryLevel2
    categoryLevel3: $categoryLevel3
    categoryLevel: $categoryLevel
  ) {
    items {
      advertLookUp
      brand
      buyNow
      endDate
      hideDate
      id
      imageUrl
      multiPrice
      multiVariant
      name
      offerTitle
      price
      retailerId
      salePrice
      savingsPercentage
      startDate
      uomDescription
      category {
        name
        categoryId
      }
      retailer {
        description
        displayName
        id
        name
      }
    }
    recommendationId
  }
}
    `;
export const GetBraintreeClientAuth = gql`
    query getBraintreeClientAuth {
  braintreeClientAuth
}
    `;
export const CartWithPayment = gql`
    query CartWithPayment($cartId: String) {
  cart(cartId: $cartId) {
    __typename
    cart {
      braintreePaymentToken
      ...CartFragment
    }
  }
}
    ${CartFragment}`;
export const Cart = gql`
    query Cart($cartId: String) {
  cart(cartId: $cartId) {
    __typename
    cart {
      ...CartFragment
    }
  }
}
    ${CartFragment}`;
export const Coupon = gql`
    query Coupon($couponCode: String!) {
  coupon(couponCode: $couponCode) {
    __typename
    couponCode
    description
    type
    startDate
    expiryDate
    dollarDiscount
    percentageDiscount
    retailerId
    retailerPercentage
    email
    usesPerEmail
    minimumAmount
    maximumDiscount
    mobileOnly
  }
}
    `;
export const Product = gql`
    query Product($productId: String!) {
  product(productId: $productId) {
    __typename
    ... on Product {
      __typename
      entityType: productType
      product_id: idAsString
      product_startDate: startDate
      product_endDate: endDate
      product_hideDate: hideDate
      product_productGroupId: productGroupId
      product_brand: brandId
      product_price: price
      product_salePrice: salePrice
      product_uomDescription: uomDescription
      product_shippingDescription: shippingDescription
      product_savingsAbsolute: savingsAbsolute
      product_savingsPercentage: savingsPercentage
      product_description: description
      product_linkUrl: linkUrl
      product_name: offerTitle
      product_categoryName: categoryName
      product_categoryId: categoryId
      product_imageUrl: imageUrl
      product_additionalImageUrl: additionalImageUrl
      product_onPage: onPage
      product_inWishList: inWishList
      product_buyNow: buyNow
      product_retailerId: retailerId
      product_productGroup: productGroup {
        ...ProductGroupParts
      }
      product_isPurchasableOnline: isPurchasableOnline
      product_multiVariant: multiVariant
      product_multiPrice: multiPrice
      product_advertLookUp: advertLookUp
      product_categorylevel1: categoryLevel1
      product_categorylevel2: categoryLevel2
      product_categorylevel3: categoryLevel3
      product_categorylevel: categoryLevel
      product_retailer: retailer {
        ...RetailerParts
        retailer_shippingEstimationMessage: shippingEstimationMessage
      }
      product_isHidden: isHidden
      product_isDuplicate: isDuplicate
      product_pageDetails: productGroupPageDetails {
        imageMap
        onPage
        pageImage
        productGroupId
      }
    }
  }
}
    ${ProductGroupParts}
${RetailerParts}`;
export const Shipments = gql`
    query Shipments($orderId: String!) {
  shipments(orderId: $orderId) {
    estimatedDeliveryDate
    shipmentId
    shippedItems {
      lineItem {
        id
      }
      shippedItemId
    }
    shippingStatus
    trackingNumber
  }
}
    `;
export const GetUserCart = gql`
    query getUserCart {
  userCart {
    __typename
    cart {
      ...CartFragment
    }
  }
}
    ${CartFragment}`;
export const Variant = gql`
    query Variant($advertId: String!, $variantId: String!, $retailerId: String!) {
  variant(advertId: $advertId, variantId: $variantId) {
    available
    availableQuantity
    id
    priceInCents
    salePriceInCents
    advancedShippingCostForVariant(retailerId: $retailerId)
  }
}
    `;